import { ApiRoutes } from './apiRoutes'

import { useApiHandler } from '@/hooks/useApiHandler'
import { OrderPayment } from '@/types/OrderPayment'
import { ApiConfig } from '@/types/api'
import { AcademicAdmission } from '@/types/forms/academicAdmission'
import {
    Inscription,
    InscriptionMoreInformation,
    InternalTransferValidation,
    ProgramEligibilityValidation,
    SimultaneousProgramValidation
} from '@/types/inscription'

export function useInscriptionsApi(config?: Partial<ApiConfig>) {
    const api = useApiHandler(ApiRoutes.INSCRIPTIONS, config)

    type FastRegisterRequest = {
        academicAdmission: AcademicAdmission | null
        idAcademicOffering?: number | null
        isClaseOyenteValid?: number
        isStatusRejectedValid?: number
        aliadoId?: number | null
        categoryId?: number | null
    }

    return {
        getInscriptions: (idAspirant: number) =>
            api.get<Inscription[]>(
                `/inscriptions/aspirant/${idAspirant}/all-inscriptions`
            ),

        getInscription: (id: string) =>
            api.get<Inscription>(`/inscriptions/${id}`),

        createInscription: (idAspirant: number, data: FastRegisterRequest) =>
            api.post<Inscription>('/inscriptions', data, {
                headers: { 'x-id-aspirant': idAspirant }
            }),

        updateInscription: (id: string, data: Partial<Inscription>) =>
            api.put<Inscription>(`/inscriptions/${id}`, data),

        deleteInscription: (id: string) =>
            api.delete<string>(`/inscriptions/${id}`),

        getOrderPayment: (idInscription: number) =>
            api.get<OrderPayment>(
                `/payment-order/inscription/${idInscription}`
            ),

        getOrderPaymentWithValidation: (idInscription: number) =>
            api.get<OrderPayment[]>(
                `/payment-order/inscription/${idInscription}/with-validation`
            ),

        getOrderFromSap: (idInscription: number) =>
            api.get<OrderPayment[]>(
                `/payment-order/inscription/${idInscription}/get-order-from-sap`
            ),

        getInscriptionMoreInformation: (idInscription: number) =>
            api.get<InscriptionMoreInformation>(
                `/inscriptions/more-information/${idInscription}`
            ),

        updatePaymentOrderStatus: (idInscription: number) =>
            api.get<any>(
                `/inscriptions/get-order-payment-status/${idInscription}`
            ),
        verifyRejectHistory: (idAspirant: number) =>
            api.get<any>(
                `/rejected-applicants-history/check-by-aspirant/${idAspirant}`
            ),

        getSimultaneousProgramValidation: (
            studnr: string,
            programCode: string
        ) =>
            api.get<SimultaneousProgramValidation>(
                '/sap-datasphere/simultaneous-program',
                { params: { studnr, programCode } }
            ),

        getInternalTransferValidation: (studnr: string, programCode: string) =>
            api.get<InternalTransferValidation>(
                '/sap-datasphere/internal-transfer',
                { params: { studnr, programCode } }
            ),

        getProgramEligibilityValidation: (
            studnr: string,
            programCode: string
        ) =>
            api.get<ProgramEligibilityValidation>(
                '/sap-datasphere/program-eligibility',
                { params: { studnr, programCode } }
            )
    }
}
